import React, { useEffect, useRef, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import dayjs from "dayjs";
import apiClient from "../../BaseUrl/apiClient.js";
import "../../css/entry.css";
import "../../css/color.css";
import TokenService from "../../service/TokenService";
import ToasterAlerts from "../../components/ToasterAlerts";
import SriyanshCardHeader from "../../components/CardHeader";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import EncryptService from "../../service/EncryptionService";
import { useNavigate } from "react-router-dom";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import { useAuthentication } from "../../customHook/useAuthentecation";
import { USER_RIGHTS } from "../../constants/constants";
import { getBottomNavigationActionUtilityClass } from "@mui/material";
const IndentEntry = () => {
  const [varindentNumber, setvarindentNumber] = useState("");
  const [vardateofIndent, setvardateofIndent] = useState(null);
  const [varitemname, setvaritemname] = useState("");
  const [varindentItemQty, setvarindentItemQty] = useState("");
  const [varindentItemValue, setvarindentItemValue] = useState("");
  const [error, setError] = useState("");
  //const [dateerror, setDateError] = useState(null);
  const today = dayjs();
  const minCalDate = dayjs("2023-04-01");
  const [errors, setErrors] = useState({});
  const [consignee, setconsignee] = useState("");
  const [consignees, setconsignees] = useState([]);
  const navigate = useNavigate();
  const [unit, setunit] = useState("");
  const [units, setunits] = useState([]);
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const consigee_consignee = tokenServiceDetails?.consignee;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const { auth } = useAuthentication();
  // console.log(consigee_consignee);
  const startRef = useRef(null);
  const handleQuantityChange = (value) => {
    setvarindentItemQty(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleValueChange = (value) => {
    setvarindentItemValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleClose = () => {
    navigate("../polist", { replace: true });
  };

  // Function to fetch Consignee from the API
  const fetchConsignees = async () => {
    try {
      const response = await apiClient.post("/ConsigneeList", {
        /* request payload if needed */
      });
      setconsignees(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const fetchUnit = async () => {
    try {
      const response = await apiClient.post("/unitList", {
        /* request payload if needed */
      });
      setunits(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const UpdateIndentData = async (e) => {
    e.preventDefault();
    let formErrors = {};

    if (!vardateofIndent) {
      formErrors.errDate = "Invalid Indent Date";
    }

    if (parseFloat(varindentItemQty) <= 0)
      formErrors.qty = "Qty should be more then zero";

    if (varindentItemValue.length === 0)
      formErrors.val = "Value should be more then zero";

    if (varindentItemQty.length === 0)
      formErrors.qty = "Qty should be more then zero";

    if (parseFloat(varindentItemValue) <= 0)
      formErrors.val = "Value should be more then zero";

    if (varindentNumber.length === 0)
      formErrors.indent = "Indent Number Should not be Blank";

    if (varitemname.length === 0)
      formErrors.name = "Item Name Should not be Blank";

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const Indentdt = new Date(vardateofIndent);
      const indentreceiptdt =
        Indentdt.getFullYear() +
        "/" +
        parseInt(Indentdt.getMonth() + 1) +
        "/" +
        Indentdt.getDate();

      apiClient
        .post("/indententry", {
          varindentNumber,
          vardateofIndent: indentreceiptdt,
          varitemname,
          consignee,
          varindentItemQty,
          varindentItemValue,
          varentryUser: uname,
          ip,
          unit,
        })
        .then(function (response) {
          setError(response.data);
          setvarindentNumber("");
          setvaritemname("");
          setvarindentItemQty([]);
          setvarindentItemValue([]);
        })
        .catch(function (error) {
          if (
            error.response.data &&
            error.response.data.code === "ER_DUP_ENTRY"
          ) {
            alert("Duplicate Indent Not Allowed");
          }
        });
    }
  };
  useEffect(() => {
    if (!consignees.length) return;

    if (auth?.userrights === USER_RIGHTS.CONSIGNEE) {
      const userConsigneeCode = String(consigee_consignee);

      const match = consignees.find(
        (c) => String(c.ConsigneeCode) === userConsigneeCode
      );

      if (match) {
        setconsignee(String(match.ConsigneeCode));
      } else {
        console.warn(
          "Consignee from token not found in list:",
          userConsigneeCode
        );
        setconsignee("");
      }
    } else {
      // Non-consignee users → select first by default
      setconsignee(String(consignees[0].ConsigneeCode));
    }
  }, [consignees, auth, consigee_consignee]);




  useEffect(() => {
    if (units.length > 0) {
      const defaultUnit = units.find(u => u.unitcode === "UNT");
      setunit(defaultUnit ? defaultUnit.unitcode : units[0].unitcode);
    }
  }, [units]);




  useEffect(() => {
    fetchConsignees();
    fetchUnit();
    // setunit("UNT");
    if (startRef.current) {
      startRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

    }
  }, []);



  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };


  // console.log("consignee:", consignee);
  return (
    <div className="col-12">
      {/* <SriyanshCardHeader Title="" /> */}
      <Card className="Formcard">
        {error && (
          <ToasterAlerts
            type="error"
            title="Messasge"
            errorMessage={error}
            displaytime={1000}
            handleClose={() => {
              setError("");
            }}






          />
        )}

        <div className="input-groupHeading">
          Indent Entry

        </div>

        <CardContent>
          <div className="row p-2" >
            <div className="container">
              <div className="input-group mt-2" >
                <CustomTextField
                  label="Enter Indent Number(Max 50 Character)*"
                  value={varindentNumber}
                  onChange={(e) => {
                    setvarindentNumber(e.target.value.toUpperCase());
                  }}
                  placeholder="Enter Indent Number(Max 50 Character)*"
                  maxLength={50} // Set the maximum length
                  error={!!errors.indent}
                  helperText={errors.indent}
                />
              </div>
              <div className="input-group" style={{ marginTop: "7px" }}>
                <DatePickerComponent
                  label="Date of Indent*"
                  id="indentdate"
                  value={vardateofIndent}
                  onChange={(newDate) =>
                    handleDateChange(newDate, setvardateofIndent)
                  }
                  error={errors.errDate}
                  maxDate={today}
                  minDate={minCalDate}

                />
              </div>
            </div>

            <div className="container">
              <div className="input-group">
                <CustomTextField
                  label="Enter Item Name(Max 200 Character)*"
                  value={varitemname}
                  onChange={(e) => {
                    setvaritemname(e.target.value);
                  }}
                  placeholder="Enter Item Name(Max 200 Character)*"
                  maxLength={200} // Set the maximum length
                  multiline={true} // Enable multiline
                  minRows={3} // Set the minimum number of rows
                  error={!!errors.name}
                  helperText={errors.name}
                />
              </div>{" "}
            </div>

            <div className="container">
              <div className="input-group">
                <NumericTextField
                  id="ItemQuantity"
                  label="Item Quantity"
                  title="Item Quantity"
                  error={errors.qty}
                  value={varindentItemQty}
                  onChange={handleQuantityChange}
                />
              </div>
              <div className="input-group">
                <DropdownfromDatabaseList
                  Options={units}
                  option={unit}
                  setOptionValue={setunit}
                  DisplayItem1="unit"
                  DisplayItem2="unitcode"
                  showKeyInLabel={true}
                />
              </div>
              <div className="input-group">
                <NumericTextField
                  id="ItemValue"
                  label="Item Value"
                  title="Item Value"
                  error={errors.val}
                  value={varindentItemValue}
                  onChange={handleValueChange}
                />
              </div>
            </div>

            <div className="container">
              <div className="input-group">
                <DropdownfromDatabaseList
                  Options={consignees}
                  // option={consignee}
                  // setOptionValue={setconsignee}
                  option={String(consignee)}
                  setOptionValue={(val) => setconsignee(String(val))}
                  DisplayItem1="Shop"
                  DisplayItem2="ConsigneeCode"
                  showKeyInLabel={true}
                  disabled={
                    auth?.userrights === USER_RIGHTS.CONSIGNEE &&
                    consignee !== "91030"
                  } // disabled is true if user is not equal to "user"
                />
              </div>
            </div>
          </div>

          <>
            <div
              className="container flex"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={UpdateIndentData}
                title="Click for Data Entry"
              >
                Data Save
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </>
        </CardContent>
      </Card>
    </div>
  );
};

export default IndentEntry;
